import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { PipelinePageUrls, PipelineSwitcherService } from '@vendasta/sales-ui';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PipelineViewRouterGuard {
  constructor(
    private readonly pipelineSwitcherService: PipelineSwitcherService,
    private readonly router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.pipelineSwitcherService.cachedPipelinePage$.pipe(
      take(1),
      map((page) => {
        if (page === PipelinePageUrls.BOARD) {
          return this.router.createUrlTree([PipelinePageUrls.BOARD]);
        }
        // Wil take them to the originally requested url (/pipeline/table)
        return true;
      }),
    );
  }
}
